function updateVariantMetafields(event) {
  //This event updates the variant metafield values in the tab block in the product page
  //when different variants are selected.
  //The variant values are stored in hidden data elements using product-variant-metafield-storage.liquid
  //These stored values are accssed based on the variant selected and the relevant div or img elements are 
  //updated based on the tags defined in the mappings dict below.
  //product-highlight.liquid defines the tab page.
  //This script is loaded in product-main.liquid

  const variant = event.detail.variant;
  if (!variant) return;

  const hiddenVariant = document.querySelector('#variant-tab-storage [data-variant-tab="' + variant.id + '"]');
  if (!hiddenVariant) return;

  const fields = {
    "spec": [
        "light_colour",
        "light_type",
        "number_of_lights",
        "light_control_options",
        "lighting_connectivity",
        "lighting_experience",
        "tip_count",
        "tree_height",
        "tree_width",
        "collection",
        "style_number",
        "product_number",
        "transformer",
        "net_weight",
        "gross_weight",
        "pe_pvc_ratio"
    ],
    "highlight": [
        "tip_count",
        "lighting_experience",
        "lighting_experience_icon",
        "lighting_experience_description",
        "number_of_lights",
        "tree_dimension_icon",
        "net_weight",
        "gross_weight",
        "premium_kit_image"
    ]
  };

  const tabCssClasses = {
    "highlight": "cell-variant",
    "spec": "spec-value"
  };

  requestAnimationFrame(() => {

    Object.entries(fields).forEach(([tab, fields]) => {
      fields.forEach(field => {

        const storage_key = `variant-${field}`;
        const targetId = `${tab}-variant-${field}`;
        const targets = document.querySelectorAll('[id="span-' + targetId + '"]');
        const source = hiddenVariant.querySelector('[data-field="' + storage_key + '"]');
        const source_dtype = source?.getAttribute('data-type'); // text or image
        const cssClass = tabCssClasses[tab];

        if (!targets.length) return;

        targets.forEach(target => {

          if (source_dtype === 'text') {
            const variant_text = source ? source.textContent.trim() : '';

            // look for target_div under *this* target only
            let target_div = target.querySelector('[id="div-' + targetId + '"]');

            if (variant_text) {
              if (!target_div) {
                target_div = document.createElement('div');
                target_div.id = "div-" + targetId;
                target_div.classList.add(cssClass);
                target.appendChild(target_div);
              }

              target_div.textContent = variant_text;

            } else {
              if (target_div) target_div.textContent = '';
            }
          }

          if (source_dtype === 'image') {
            const src_url = source ? source.textContent.trim() : '';

            // look for image tag under *this* target only
            let target_img = target.querySelector('[id="img-' + targetId + '"]');

            if (src_url) {
              if (!target_img) {
                target_img = document.createElement('img');
                target_img.id = "img-" + targetId;
                target_img.classList.add('cell-image');
                target.appendChild(target_img);
              }
              target_img.src = src_url;
              target_img.style.display = ''; // ensure visible
            } else {
              if (target_img) target_img.style.display = 'none';
            }
          }

        }); // end targets.forEach
      }); // end fields.forEach
    }); // end Object.entries
  }); // end requestAnimationFrame
}

// Function to show/hide divs based on variant in What's In the Box
function toggleWhatInTheBoxDivs(event) {
  const variant = event.detail.variant;
  if (!variant) return;

  // Get the hidden storage for this variant
  const hiddenVariant = document.querySelector(`#variant-tab-storage [data-variant-tab="${variant.id}"]`);
  if (!hiddenVariant) return;

  // Get the lighting experience value for this variant
  const lightingField = hiddenVariant.querySelector('[data-field="variant-lighting_experience"]');
  const lightingExperience = lightingField ? lightingField.textContent.trim() : '';

  // Define the target IDs to toggle
  const targetIds = ['box-div-remote-controller'];

  targetIds.forEach(id => {
    // Select all divs in the DOM
    const elements = document.querySelectorAll(`[id="${id}"]`);
    elements.forEach(el => {
      // Hide if 10-Mode Magic Light Show, show if Enchanted Light Show
      if (lightingExperience === '10-Mode Magic Light Show') {
        el.style.display = 'none';
      } else if (lightingExperience === 'Enchanted Light Show') {
        el.style.display = ''; // show
      }
    });
  });
}

// Utility to attach multiple handlers
function addVariantChangeHandler(...handlers) {
  handlers.forEach(handler => document.addEventListener('variant:change', handler));
}

// Attach all handlers in one place
addVariantChangeHandler(updateVariantMetafields, toggleWhatInTheBoxDivs);